var C0092;
$(document).ready(function() {
	if(!document.querySelector('.C0092')) return false;

	C0092 = {
		el: null,
		tab : null,
		opt: {
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows : true,
			dots: true,
			listStyle: true, // LGEGMO-5525 add
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					arrows : true
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows : false
				}
			}],
			prevArrow: carouselOptions.bigAnglePrev, // common.js variable
			nextArrow: carouselOptions.bigAngleNext // common.js variable
		},
		template: null,
		init: function(){
			var _this = C0092;
			var els = document.querySelectorAll('.C0092');

			for (var i = 0; i < els.length; i++) {
				_this.el = els[i];
				_this.tab = _this.el.querySelector('.tabs-type-liner');
				_this.template = $(_this.el).find('.contents-template').clone();
				$(_this.el).find('.contents-template').remove();

				// get Recently products
				var _recentlyModelsList = _this.el.querySelector('input[name="recentlyModelsList"]');
				if(_recentlyModelsList) {
					var $nav = $('.navigation');
					var list = ($nav && $nav.hasClass('b2b')) ? getCookie("LG5_B2B_RecentlyView") : getCookie("LG5_RecentlyView"),
						$content = $(_recentlyModelsList).closest(".tabs-cont");
					_recentlyModelsList.value = list ? list : "";

					if(list == undefined) {
						$content.find("form").remove();
					}else {
						$content.find(".no-content").remove();
					}
				}

				_this.addEvent();
				if(_this.tab && !$(_this.tab.querySelector('a')).is('.active')) {
					$(_this.tab.querySelector('a')).trigger('click');
				}
			}
			scrollDesign();
		},
		createProductItem: function(productList){
			var html = [];
			for (var i = 0; i < productList.length; i++) {
				var p = productList[i],
					template = $(C0092.template).clone().html();
				template = template.replace(/\*modelId\*/g, p.modelId)
								//PJTUSGA-1
								.replace(/\*productIndex\*/g, i+1)
								.replace(/\*modelName\*/g, p.modelName)
								/* LGEUS-188 : 20200515 add */
								.replace(/\*buName1\*/g, p.buName1)
								//LGEUS-12424
								.replace(/\*replaceModelName\*/g, p.modelName.toString().replace(/ /gi, "_"))
								.replace(/\*imageAltText\*/g, p.imageAltText)
								.replace(/\*userFriendlyName\*/g, p.userFriendlyName)
								.replace(/\*salesModelCode\*/g, p.salesModelCode)
								.replace(/\*modelUrlPath\*/g, p.modelUrlPath)
								.replace(/\*mediumImageAddr\*/g, p.mediumImageAddr)
								.replace(/\*smallImageAddr\*/g, p.smallImageAddr)
								.replace(/\*productTag1\*/g, p.productTag1)
								.replace(/\*productTag2\*/g, p.productTag2)
								/* LGEUS-12198 : 20191024 Removed */
								.replace(/\*inquiryToBuyUrl\*/g, p.inquiryToBuyUrl)
								.replace(/\*findTheDealerUrl\*/g, p.findTheDealerUrl)
								.replace(/\*promotionText\*/g, p.promotionText ? p.promotionText : "")
								.replace(/\*rPrice\*/g, p.rPrice ? p.rPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? p.rPromoPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								.replace(/\*rPriceCent\*/g, p.rPriceCent)
								.replace(/\*rPromoPriceCent\*/g, p.rPromoPriceCent)
								/* LGEUS-12083 : 20190826 add */
								.replace(/\*rDiscountedPrice\*/g, p.rDiscountedPrice ? p.rDiscountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								.replace(/\*rDiscountedPriceCent\*/g, p.rDiscountedPriceCent)
								/* //LGEUS-12083 : 20190826 add */
								.replace(/\*siblingType\*/g, p.siblingType)
								.replace(/\*discountedRate\*/g, p.discountedRate)
								.replace(/\*retailerPricingText\*/g, p.retailerPricingText);
				
				/* LGEUS-12198 : 20191024 add */
				if (p.wtbExternalLinkUseFlag=='Y') {
					template = template.replace(/\*whereToBuyUrl\*/g, p.wtbExternalLinkUrl)
							   .replace(/\*whereToBuyTarget\*/g, p.wtbExternalLinkSelfFlag=='N' ? "_blank" : "_self")
							   .replace(/\*whereToBuyTitle\*/g, p.wtbExternalLinkSelfFlag=='N' ? $(template).find('a.where-to-buy').attr('data-link-text') : "")
							   .replace(/\*whereToBuyName\*/g, p.wtbExternalLinkName);
				} else {
					template = template.replace(/\*whereToBuyUrl\*/g, p.whereToBuyUrl)
							   .replace(/\*whereToBuyTarget\*/g, "_self")
							   .replace(/\*whereToBuyTitle\*/g, "")
							   .replace(/\*whereToBuyName\*/g, $(template).find('a.where-to-buy').attr('data-link-text'));
				}
				/* //LGEUS-12198 : 20191024 add */
				
				var $template = $(template),
					$keyBlocks = $template.find('*[data-key]');

				for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
					/* LGEUS-12198 : 20191024 add */
					var $currentKeyBlock = $keyBlocks.eq(i1);
					var key = $currentKeyBlock.get(0).getAttribute('data-key');
					if (p.wtbExternalLinkUseFlag=='Y' && key=="whereToBuyFlag") { 
						key = "wtbExternalLinkUseFlag"; 
					}
					var val = p[key];
					/* //LGEUS-12198 : 20191024 add */
					if(!val || (val == null || val == "N")) {
						if($currentKeyBlock.is('.btn')) {
							$currentKeyBlock.removeClass('active');
						}else {
						 	$currentKeyBlock.remove();
						}
						//$currentKeyBlock.remove();
					}else {
						if($currentKeyBlock.is('.btn')) {
							$currentKeyBlock.addClass('active');
						}
					}
				}

				// price setting
				var $prices = $template.find('.price-area');
				// DC-680 20210526 modify
				if(p.modelStatusCode=='DISCONTINUED') {
					$prices.filter('.rPrice').html("");
					$prices.filter('.rPromoPrice').remove();
					$prices.filter('.retailer').remove();
				} else if (p.obsCondition == "Y") {
					if((p.rPromoPrice && p.rPromoPrice != null) && (p.rPrice && p.rPrice != null)) {
						$prices.filter('.rPrice').remove();
						$prices.filter('.retailer').remove();
					}else if(p.rPrice && p.rPrice != null){
						$prices.filter('.rPromoPrice').remove();
						$prices.filter('.retailer').remove();
					}else {
						$prices.filter('.rPrice').html("");
						$prices.filter('.rPromoPrice').remove();
						$prices.filter('.retailer').remove();
					}
				} else {
					if(p.retailerPricingFlag=="Y") {
						$prices.filter('.rPrice').remove();
						$prices.filter('.rPromoPrice').remove();
					}else {
						if((p.rPromoPrice && p.rPromoPrice != null) && (p.rPrice && p.rPrice != null)) {
							$prices.filter('.rPrice').remove();
							$prices.filter('.retailer').remove();
						}else if(p.rPrice && p.rPrice != null){
							$prices.filter('.rPromoPrice').remove();
							$prices.filter('.retailer').remove();
						}else {
							$prices.filter('.rPrice').html("");
							$prices.filter('.rPromoPrice').remove();
							$prices.filter('.retailer').remove();
						}
					}
				}
				// DC-680 20210526 modify

				// sibling target check
				if(p.target && p.target.toUpperCase() == "SELF") {
					$template.filter('.item.js-model').addClass('self');
				}else {
					$template.filter('.item.js-model').removeClass('self');
				}

				// siblingModels
				var $sibling = $template.find('.model-group .inner');
				var siblingTypeclass;
				if(p.siblingType && p.siblingType != null) {
					siblingTypeclass = (p.siblingType.toLowerCase() == "color") ? "color" : "size";
				}else {
					siblingTypeclass = null;
				}
				if(p.siblingModels != null && (p.siblingModels.length > 0 && siblingTypeclass != null) && $sibling.get(0)) {
					var siblingItem = $template.find('.model-group .'+siblingTypeclass).clone().html(),
						siblingMarkup = [];

					for (var _j = 0; _j < p.siblingModels.length; _j++) {
						var sbModel = p.siblingModels[_j];
						var item = siblingItem.replace(/\*siblingCode\*/g, sbModel.siblingCode)
											.replace(/\*siblingValue\*/g, sbModel.siblingValue)
											.replace(/\*subModelId\*/g, sbModel.modelId);
						if(sbModel.modelId != p.modelId) {
							item = item.replace('active', '');
						}
						siblingMarkup += item;
					}
					$sibling.append(siblingMarkup);
					/* PJTWAUS-1 : 20200310 add */
					var ariaModelName = p.userFriendlyName;
					if(ariaModelName == ''){
						ariaModelName = p.modelName;
					}					
					$sibling.attr('aria-label', ariaModelName + ' ' +siblingTypeclass + ' group');
					/*// PJTWAUS-1 : 20200310 add */

				}

				// rolling image
				if(p.modelRollingImgList && p.modelRollingImgList != null) {
					$template.find('.visual img.pc').addClass('js-thumbnail-loop').attr('data-img-list', p.modelRollingImgList);
				}

				$template.find('template').remove();
				template = $template.get(0).outerHTML;
				html += template;
			}

			return html;
		},
		addEvent: function(){
			var _this = C0092;
			$(_this.el).on({
				submit: function(e){
					e.preventDefault();
					var isExpander = $(e.delegateTarget).data('focus') == true;
					var url = e.currentTarget.action,
						param = encodeURI(xssfilter($(e.currentTarget).serialize()));
					var $target = $(e.currentTarget).siblings('.list-contents-wrap');
					var $form = $(e.currentTarget);

					ajax.noCacheCall(url, param, 'json', function(d){
						var data, html;
						if(d && d.data) data = d.data instanceof Array ? d.data[0] : d.data;

						if(d.status == "success" && (data && (data.productList && data.productList.length > 0))) {
							// making markup
							html = C0092.createProductItem(data.productList);

							if($target.find('.unit-list').is('.slick-initialized')) {
								$target.find('.unit-list').slick('unslick');
							}
							
							$target.find('.unit-list').html(html);
							bindImgError();
							if($target.hasClass('initialized')) {
								$('html, body').animate({
									scrollTop: $target.closest('.component').offset().top
								});
							}

							$target.find('.unit-list').slick(C0092.opt);
							$target.addClass('initialized');

							$form.trigger('ajaxLoadEnd');
						}else {
							$target.closest(".tab-cont").removeClass("active");
							$target.closest(".component").find(".no-content-wrap").addClass("active");

							$form.trigger('ajaxLoadEnd');
						}
					});
				}
			}, 'form');

			// tab click
			$(_this.tab).on({
				click: function(e){
					e.preventDefault();
					var target = $(e.currentTarget.getAttribute('href')).get(0),
						targetForm = target.querySelector('form');

					// hide no-content area
					$(target).closest(".component").find(".no-content-wrap").removeClass("active");
					
					if($(targetForm).length>0) {
						if(!$(target.querySelector('.list-contents-wrap')).is('.initialized')) {
							if($(targetForm).find('input[name=type][value=EO]').length>0 || $(targetForm).find('input[name=type][value=YMAL]').length>0) {
								if(typeof OBS.init == 'function') {
									OBS.init($(target));
								} else {
									$(targetForm).submit();
								}
							} else {
								$(targetForm).submit();
							}
						}
					} else {
						if(!$(target).hasClass('active')) {
							$(target).addClass('active');
						}
						if(!$(target.querySelector('.list-contents-wrap')).find('.unit-list').hasClass('slick-initialized')) {
							setTimeout(function() {
								$(target.querySelector('.list-contents-wrap')).find('.unit-list').slick(C0092.opt);
							}, 100);
						}
					}
				}
			}, 'a');
		}
	};

	C0092.init();
});
